
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.499 15a2.252 2.252 0 01-2.25-2.25V10.5h-9.75a.75.75 0 010-1.5h9.75V7.5h-9.75a.75.75 0 010-1.5h9.98l1.541-4.113A2.932 2.932 0 0115.748 0a2.93 2.93 0 012.73 1.89l1.723 4.597a.734.734 0 01.048.263v6a2.252 2.252 0 01-2.25 2.25h-4.5zm-.75-2.25c0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75V6.886l-1.675-4.468a1.421 1.421 0 00-1.325-.918v-.375.375c-.585 0-1.118.368-1.325.915l-1.675 4.47v5.865zM15.749 24a.75.75 0 01-.75-.75V19.5h-1.5a.75.75 0 010-1.5h4.5a.75.75 0 010 1.5h-1.5v3.75a.75.75 0 01-.75.75zM20.999 18a.752.752 0 01-.53-1.281l1.5-1.5a.744.744 0 011.06 0 .752.752 0 010 1.061l-1.5 1.5a.741.741 0 01-.53.22zM22.499 22.5a.743.743 0 01-.53-.22l-1.5-1.5a.752.752 0 01.53-1.281c.2 0 .389.078.53.22l1.5 1.5a.752.752 0 01-.53 1.281zM10.499 18a.743.743 0 01-.53-.22l-1.5-1.5a.752.752 0 010-1.061.748.748 0 011.06.001l1.5 1.5a.752.752 0 010 1.061.744.744 0 01-.53.219zM8.999 22.5a.752.752 0 01-.53-1.281l1.5-1.5a.744.744 0 011.06 0 .752.752 0 010 1.061l-1.5 1.5a.741.741 0 01-.53.22z"}})])
          )
        }
      }
    